import {mapGetters, mapMutations, mapActions} from 'vuex'

import _ from 'lodash'
import moment from 'moment'

import reviewImg from '@/components/review-img/index.vue'
export default {
  name: 'searchProperty',
  //---components
  components: {
    reviewImg
  },
  //---data
  data () {
    return {
      propertyInfo: {
        isPurchase: false,
        isSearchLoading: false,
        isSearchErrorShow: false,
        search: undefined,
        searchModel: null,
        isShowDatepickerMenu: false,
        isValidPurchaseForm: true
      },
      propertyAdditional: {
        purchasePrice: null,
        purchaseDate: null,
        isForeclosure: false
      },
      purchaseFlag: false,
    }
  },
  //---hooks
  created () {
    //---reset data
    if (this.analysis !== null) {
      this.setAnalysis(null);
    }
    if (this.report !== null) {
      this.setReport(null);
    }
  },
  computed: {
    ...mapGetters({
      client: 'CLIENT/client',
      content: 'APP/content',
      searchQuery: 'SEARCH/searchQuery',
      analysis: 'ANALYSIS/analysis',
      report: 'REPORT/report',
    }),
    purchasedYear: function () {
      return new Date().getFullYear() - 3;
    },
    formmatedDate: function() {
      return this.propertyAdditional.purchaseDate ? moment(this.propertyAdditional.purchaseDate).format('MM/DD/YYYY') : '';
    },
    isBtnDisabled: function () {
      return !this.propertyInfo.search || !!this.propertyInfo.search && this.propertyInfo.isPurchase && !this.propertyInfo.isValidPurchaseForm
    }
  },
  watch: {
    'propertyInfo.searchModel': function (searchText) {
      this._changeQuery(searchText);
    },
  },
  //---methods
  methods: {
    ...mapMutations({
      setSearchQuery: 'SEARCH/SEARCH_QUERY_SET',
      setReport: 'REPORT/REPORT_SET',
      setAnalysis: 'ANALYSIS/ANALYSIS_SET',
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
    }),
    ...mapActions({
      getSearchQuery: 'SEARCH/SEARCH_QUERY_REQUEST_GET',
      getAnalysis: 'ANALYSIS/ANALYSIS_REQUEST_GET',
    }),

    _changeQuery: _.debounce(function (searchText) {
      if (searchText && searchText.length >= 2){
        if (!this.propertyInfo.search || this.propertyInfo.search && searchText !== this.propertyInfo.search.fullAddress) {
          this.propertyInfo.isSearchLoading = true;
          this.getSearchQuery(searchText).finally(()=>{
            this.propertyInfo.isSearchErrorShow = this.searchQuery.length === 0;
            this.propertyInfo.isSearchLoading = false;
          });
        }
      } else {
        this.setSearchQuery([]);
      }
    }, 500),

    addressFilter (item, queryText, itemText) {
      const getValue = val => val != null ? val.toString().toLowerCase() : '';

      const fullAddress = getValue(item.fullAddress);
      const pin = getValue(item.pin);
      const formattedPin = getValue(item.formattedPin);
      const query = getValue(queryText);

      return fullAddress.indexOf(query) > -1 ||
        pin.indexOf(query) ||
        formattedPin.indexOf(query)
    },

    clearSearchError() {
      this.propertyInfo.isSearchErrorShow = false
    },

    changePropertyAdditional() {
      if (!this.propertyInfo.isPurchase) {
        setTimeout(()=>{
          this.$refs.propertyAdditionalForm.reset();
          this.propertyAdditional = {
            purchasePrice: null,
            purchaseDate: null,
            isForeclosure: false
          }
        },400);
      }
    },

    analyze() {
      this.loaderFlag(true);
      let dataForAnalysis = {
        propertyAddressId: this.propertyInfo.search.propertyAddressId,
        purchase: {
          purchasePrice: this.propertyAdditional.purchasePrice ? this.propertyAdditional.purchasePrice : null,
          purchaseDate: this.propertyAdditional.purchaseDate ? this.propertyAdditional.purchaseDate : null,
          isShortSaleOrForeclosure: this.propertyAdditional.isForeclosure
        },
        affiliateCode: this.client.affiliateCode
      }
      this.getAnalysis(dataForAnalysis).then(()=>{

        this.setSearchQuery([]);

        if (this.analysis.suggestedAppeal.id === 10) {
          //---unsupported property
          this.$router.push({name: 'unsupported'});
        } else {
          if (this.client.requireUserRegistration || this.client.collectAnalysisFee ) {
            this.$router.push({name: 'contacts'});
          } else {
            this.$router.push({name: 'analysis'});
          }
        }
      }).finally(()=>{
        this.loaderFlag(false);
      })

    }
  }
}
